import { render, staticRenderFns } from "./BatchReviewModal.vue?vue&type=template&id=6ae77231&scoped=true&"
import script from "./BatchReviewModal.vue?vue&type=script&lang=js&"
export * from "./BatchReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchReviewModal.vue?vue&type=style&index=0&id=6ae77231&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae77231",
  null
  
)

export default component.exports